import React from 'react';
import { Form, Select } from 'antd';
import { useTranslation } from 'react-i18next';

const ANNEX_OPTIONS = [
  { value: 'ANNEX1', labelKey: 'governmentServiceEducation.annex1' },
];

export const AnnexSelect = () => {
  const { t } = useTranslation();

  const options = ANNEX_OPTIONS.map(({ value, labelKey }) => ({
    value,
    label: t(labelKey),
  }));

  return (
    <Form.Item
      name='annex'
      rules={[{ required: true, message: t('error.requiredField') }]}
    >
      <Select placeholder={t('governmentServiceEducation.annex')} options={options} />
    </Form.Item>
  );
};
